<script setup>
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    inputId: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    text: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    marginTop: {
        type: String,
        default: '0'
    },
    marginBottom: {
        type: String,
        default: '0'
    },
    marginLeft: {
        type: String,
        default: '0'
    },
    marginRight: {
        type: String,
        default: '0'
    },
    labelRightmargin: {
        type: String,
        default: '2rem'
    },
    options: {
        type: Array,
        default: () => []
    },
    visible: {
        type: Boolean,
        default: true
    },
    readonly: {
        type: Boolean,
        default: false
    },
    errmsg: {
        type: String,
        default: ''
    },
    icon: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: ''
    },
    height: {
        type: String,
        default: '3rem'
    }
});

const emit = defineEmits(['update:modelValue', 'click']);
const ValidationMsg = ref('');
const errMessage = ref(props.errmsg);
const isReadonly = computed(() => props.readonly);

onMounted(() => {
    // emit('update:modelValue', props.modelValue);
});

const handleClick = () => {
    // emit('update:modelValue', 'click');
    emit('click', 'click');
};
</script>

<template>
    <div
        v-if="visible"
        class="flex flex-col"
        :style="{
            marginTop: marginTop,
            marginBottom: marginBottom,
            marginLeft: marginLeft,
            marginRight: marginRight
        }"
    >
        <label v-if="props.label.toLowerCase() !== 'empty'" :class="['label-font mb-1']">
            {{ label }}
        </label>

        <div>
            <span
                :id="inputId"
                @click="handleClick"
                :title="title"
                :class="['label-custom', required ? 'label-required' : 'text-black dark:text-gray-300']"
                :style="{
                    height: height
                }"
            >
                <i v-if="icon" :class="icon" class="mr-2"></i>
                <span  v-html="text"></span>
            </span>
        </div>
    </div>
</template>

<style scoped>
span {
    white-space: normal; /* 텍스트가 줄 바꿈이 되도록 설정 */
    overflow: visible; /* 스크롤이 생기도록 */
}
.label-font {
    font-family: 'SCoreDream600';
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    margin-bottom: 0.25rem;
    margin-left: 0.25rem;
    height: 1.3rem;
}

.label-required {
    color: #f87171; /* red-500 */
}

.label-required::before {
    content: '※';
    color: #f87171;
    margin-right: 1.25rem;
}

.label-custom {
    /* height: 2.5rem; */
    font-family: 'SCoreDream400';
    font-size: 0.875rem;
    padding: 0.375rem 0.5rem;
    min-width: 6rem;
    color: black;
    transition: all 300ms ease-in-out;
    display: flex;
    align-items: center;
    justify-content: left;
}
</style>
